import { Link } from "react-router-dom";
import { recipes } from "../data/recipes";

const CardsSection = () => {
  return (
    <section className="py-20 bg-[#fff9e6]">
      <div className="max-w-7xl mx-auto px-6 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {recipes.slice(0, 4).map((card) => (
          <Link
            key={card.slug}
            to={`/recipes/${card.slug}`}
            className="group"
          >
            <div className="rounded-2xl overflow-hidden border-4 border-[#c27a7a] bg-[#c27a7a]">
              <div className="h-[360px] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition"
                />
              </div>
              <div className="px-4 py-4 text-center">
                <h5 className="text-white font-serif text-lg">
                  {card.title}
                </h5>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CardsSection;
